// extracted by mini-css-extract-plugin
export default {"root":"BrandCollabPage_root__1opdG"};